import config from 'config/config'
import React from 'react'
import { Table } from 'semantic-ui-react'
import ComponentPlaceholder from '../../Helper/ComponentPlaceholder'
import Fragment from 'react-dot-fragment'
import CartRow from './CartRow'
import DealerFooter from './DealerFooter'
import CustomerFooter from './CustomerFooter'

class CustomerCart extends React.Component {
  basketProducts() {
    const { cart = {}, dealerVersion } = this.props
    const { data = {} } = cart
    const { products: cartProducts = [] } = data
    return cartProducts.map((cartProduct = {}, index) => (
      <CartRow
        key={index}
        cartProduct={cartProduct}
        dealerVersion={dealerVersion}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    const { cart = {}, dealerVersion } = this.props
    const { data = {} } = cart
    if (!cart.id) return <ComponentPlaceholder />
    return (
      <Fragment>
        <Table
          inverted={dark}
          compact
          size="small"
          selectable
          singleLine
          basic="very"
          className="spaced">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell collapsing>Art. Nr.</Table.HeaderCell>
              <Table.HeaderCell width="8">Produkt</Table.HeaderCell>
              <Table.HeaderCell collapsing textAlign="right">
                Anzahl
              </Table.HeaderCell>
              {dealerVersion && <Table.HeaderCell /> }
              <Table.HeaderCell collapsing textAlign="right">
                Einzelpreis
              </Table.HeaderCell>
              <Table.HeaderCell collapsing textAlign="right">
                Gesamtpreis
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body children={this.basketProducts()} />
          {dealerVersion ? <DealerFooter data={data} /> : <CustomerFooter  data={data} />}
        </Table>
      </Fragment>
    )
  }
}

export default CustomerCart



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CustomerCart/CustomerCart.jsx